import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { GeneralInsurerForm } from "./components/generalInsurerForm";
import { postData } from "../../../services";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";


const AddGeneralInsurer = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const handleAddInsurer = async (insurerData) => {
    try {
      const insurerPostData = {
        companyName: insurerData?.companyName,
        companyCode: insurerData?.companyCode,
        companyType: insurerData?.companyType?.value,
        websiteUrl: insurerData?.websiteUrl,
        sortOrder: insurerData?.sortOrder ? parseInt(insurerData.sortOrder, 10) : null,
        isActive: insurerData.active
      }
      const response = await postData("/reference/general/insurer-master", insurerPostData);

      if (response?.success) {
        showSnackbar(response?.message, "success");
        setTimeout(() => {
          navigate("/general-master/general-insurer");
        }, 1000);
      }else{
        showSnackbar(response?.message, "error");
      }
    }catch(error){
      console.error("Error fetching data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }
    finally{
      setCircleLoading(false)
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-insurer")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Insurer details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Insurer details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralInsurerForm onsubmit={handleAddInsurer} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddGeneralInsurer;
